<template>
    <div class="admin-user-tabs-shell">
        <nav class="admin-user-tabs" :aria-label="trans('user.user')">
            <ul class="admin-user-tabs__list">
                <li class="admin-user-tabs__item-wrap">
                    <router-link
                        :to="`/user/${id}/basic`"
                        class="admin-user-tabs__link"
                        :class="{ 'admin-user-tabs__link--active': menu === 'basic' }"
                    >
                        <span class="admin-user-tabs__icon" aria-hidden="true"><admin-icon name="user"></admin-icon></span>
                        <span class="admin-user-tabs__text">{{ trans('user.basic') }}</span>
                    </router-link>
                </li>
                <li class="admin-user-tabs__item-wrap">
                    <router-link
                        :to="`/user/${id}/contact`"
                        class="admin-user-tabs__link"
                        :class="{ 'admin-user-tabs__link--active': menu === 'contact' }"
                    >
                        <span class="admin-user-tabs__icon" aria-hidden="true"><admin-icon name="address-book"></admin-icon></span>
                        <span class="admin-user-tabs__text">{{ trans('user.contact') }}</span>
                    </router-link>
                </li>
                <li class="admin-user-tabs__item-wrap">
                    <router-link
                        :to="`/user/${id}/avatar`"
                        class="admin-user-tabs__link"
                        :class="{ 'admin-user-tabs__link--active': menu === 'avatar' }"
                    >
                        <span class="admin-user-tabs__icon" aria-hidden="true"><admin-icon name="user"></admin-icon></span>
                        <span class="admin-user-tabs__text">{{ trans('user.avatar') }}</span>
                    </router-link>
                </li>
                <li class="admin-user-tabs__item-wrap">
                    <router-link
                        :to="`/user/${id}/social`"
                        class="admin-user-tabs__link"
                        :class="{ 'admin-user-tabs__link--active': menu === 'social' }"
                    >
                        <span class="admin-user-tabs__icon" aria-hidden="true"><admin-icon name="share"></admin-icon></span>
                        <span class="admin-user-tabs__text">{{ trans('user.social') }}</span>
                    </router-link>
                </li>
                <li v-if="id != getAuthUser('id')" class="admin-user-tabs__item-wrap">
                    <router-link
                        :to="`/user/${id}/password`"
                        class="admin-user-tabs__link"
                        :class="{ 'admin-user-tabs__link--active': menu === 'password' }"
                    >
                        <span class="admin-user-tabs__icon" aria-hidden="true"><admin-icon name="key"></admin-icon></span>
                        <span class="admin-user-tabs__text">{{ trans('user.reset_password') }}</span>
                    </router-link>
                </li>
                <li v-if="getConfig('email_template')" class="admin-user-tabs__item-wrap">
                    <router-link
                        :to="`/user/${id}/email`"
                        class="admin-user-tabs__link"
                        :class="{ 'admin-user-tabs__link--active': menu === 'email' }"
                    >
                        <span class="admin-user-tabs__icon" aria-hidden="true"><admin-icon name="mail"></admin-icon></span>
                        <span class="admin-user-tabs__text">{{ trans('user.email') }}</span>
                    </router-link>
                </li>
            </ul>
        </nav>
    </div>
</template>

<script>
    export default {
        props: {
            menu: {
                default: ''
            },
            id: {
                required: true
            }
        },
        methods: {
            getAuthUser(name) {
                return helper.getAuthUser(name);
            },
            getConfig(config) {
                return helper.getConfig(config);
            }
        }
    }
</script>

<style scoped>
.admin-user-tabs-shell {
    background: transparent;
    border-bottom-color: #e5e7eb;
}

.admin-user-tabs__list {
    background: transparent;
    border: 0;
    box-shadow: none;
}

.admin-user-tabs__link {
    color: #64748b;
    font-weight: 500;
}

.admin-user-tabs__link:hover {
    background: transparent;
    color: #0f172a;
}

.admin-user-tabs__icon {
    background: transparent;
}

.admin-user-tabs__icon .icon.fi {
    color: inherit;
}

.admin-user-tabs__link--active {
    background: transparent;
    color: #0f172a;
    box-shadow: none;
}

.admin-user-tabs__link--active:hover,
.admin-user-tabs__link--active:visited {
    color: #0f172a;
}

.admin-user-tabs__link--active .admin-user-tabs__icon {
    background: transparent;
}

.admin-user-tabs__link--active .admin-user-tabs__icon .icon.fi {
    color: inherit;
}
</style>
